import { isFeatureEnabled } from 'owa-feature-flags';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import {
    UnifiedGroupIdentity,
    UnifiedGroupIdentityType,
    UnifiedGroupPrivacyTaskJsonResponse,
    getServiceAsync,
} from '../../../../service';
import { getGroupOwsOptions } from '../utils/groupsOwsUtils';
import { runOwsRequestWithMonitor, Feature } from '../../../../shared';

export function createGroupPrivacyTaskRequest(
    groupId: string,
    groupSmtp: string
): Promise<UnifiedGroupPrivacyTaskJsonResponse> {
    const groupIdentity: UnifiedGroupIdentity =
        isFeatureEnabled('grp-useEOIDAsIdentityForGroupsAPIs') && groupId
            ? {
                  Type: UnifiedGroupIdentityType.ExternalDirectoryObjectId,
                  Value: groupId,
              }
            : {
                  Type: UnifiedGroupIdentityType.SmtpAddress,
                  Value: groupSmtp,
              };

    return getServiceAsync().then(service =>
        service.Operation.createUnifiedGroupPrivacyTaskCommandOperation(
            {
                Header: getJsonRequestHeader(),
                Body: service.Factory.CreateUnifiedGroupPrivacyTaskRequest({
                    GroupIdentity: groupIdentity,
                }),
            },
            getGroupOwsOptions(groupSmtp)
        )
    );
}

export default function createUnifiedGroupPrivacyTask(
    groupId: string,
    groupSmtp: string
): Promise<UnifiedGroupPrivacyTaskJsonResponse> {
    return runOwsRequestWithMonitor({
        scenarioName: 'CreateUnifiedGroupPrivacyTask',
        feature: Feature.UnifiedGroups,
        operation: () => createGroupPrivacyTaskRequest(groupId, groupSmtp),
        transformResponse: (owsResponse: UnifiedGroupPrivacyTaskJsonResponse) => owsResponse,
    });
}
